import React from 'react';
import ParallaxContainer from '../../ParallaxContainer/ParallaxContainer.jsx';
import ParallaxItem from '../../ParallaxItem/ParallaxItem.jsx';
import MobileDetect from 'mobile-detect';
export default class CoverPage extends React.Component {
    constructor() {
        super(...arguments);
        this.state={
            showImage: false,
            showVideo: true              
        };
        this.checkVideoPlaying = this.checkVideoPlaying.bind(this);
    }
    componentDidMount() {
        let mobiledetect = new MobileDetect(navigator.userAgent||navigator.vendor||window.opera);
        if(mobiledetect.mobile()) {
            console.log("DETECTED MOBILE");
            this.setState({
                showImage:true,
                showVideo:false
            })
        }
    }
    checkVideoPlaying() {
        let isplaying = !!(this.refs.video.currentTime > 0 && 
            !this.refs.video.paused && 
            !this.refs.video.ended && 
            this.refs.video.readyState > 2);
        if(isplaying) {
            console.log("ISPLAYING");
            this.setState({showVideo:true, showImage:false})
        } else {
            console.log("ISNOTPLAYING");
            this.setState({showVideo:false, showImage:true})
        }   
    }
    componentDidUpdate(prevProps, prevState) {
        if(prevState.showImage != this.state.showImage || prevState.showVideo != this.state.showVideo) {
            
        }    
    }
    render() {
        return (<ParallaxContainer pwidth={16} pheight={6} minHeight="380px">
            <ParallaxItem extraHeight="40%">
                <video ref="video" style={{
                    objectFit:"cover",
                    width:"100%",
                    height:"100%",
                    display:this.state.showVideo?"block":"none",
                    objectPosition: "10% 0"
                }} 
                src="videos/topvid.mp4"
                autoPlay muted/>
                <div style={{
                    width:"100%",
                    height:"100%",
                    display:this.state.showImage?"block":"none",
                    backgroundSize: "cover",
                    backgroundImage: "url(images/topimage.jpg)",
                    backgroundPosition: "10% 0"    
                }}    
                />
            }
            </ParallaxItem>
            <ParallaxItem>
                <div
                style={{
                    position:"absolute",
                    width:"100%",
                    height:"100%",
                    backgroundImage:"url(images/crosshatch.png)",
                }} 
                src="images/horzlines.png"></div>
                <div className="covergradient" />
                <div className="coverspacer" />
                <br/>
                <br/>
                <br/>
                <div className="row">
                    <div className="col l4 push-l7 m6 push-m6">
                        <h1 className="white-text text-shadow">Shipping's <span style={{whiteSpace: "nowrap"}}>Dirty Secrets</span></h1>
                        <div className="white-text text-shadow">Cargo passing through Asian ports more than tripled since 2000. Is Asia, or the world, doing enough to tackle the environmental fallout?</div>
                        <div className="white-text inset-text text-shadow byline">By <a href="https://twitter.com/lajoiemedia">Marc Lajoie</a></div>
                        <div className="white-text inset-text text-shadow published-date">Published May 19th, 2016</div>
                    </div>
                </div>
            
            </ParallaxItem>    
        </ParallaxContainer>)
    }
}

/*CoverPage.contextTypes = {
    isMobile: React.PropTypes.bool
};*/

/*
onPlay={() => { 
                    this.setState({showVideo:true, showImage:false}) 
                                   
                }}
                onCanPlay={() => setTimeout(this.checkVideoPlaying,300)}></video>
                */


// WEBPACK FOOTER //
// ./src/js/components/special/CoverPage/CoverPage.jsx